import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
import React from "react";
import { Select } from "~/features/ui/form/select";
import { Input } from "~/features/ui/form/input";
type Props = {
  prefixes: string[];
  label?: string;
  error?: string;
  value?: string;
  onChange?: (value: string) => void;
};
export function validatePhoneNumber(value: string) {
  const [prefix, number] = value.split(" ");
  return Boolean(prefix) && Boolean(number);
}
export function PhoneNumber(props: Props & React.ComponentPropsWithRef<"input">) {
  const {
    label,
    prefixes,
    error,
    value = "",
    onChange,
    ...rest
  } = props;
  const [currentPrefix, setCurrentPrefix] = React.useState(value.split(" ")[0] || prefixes[0]);
  const [currentNumber, setCurrentNumber] = React.useState(value.split(" ")[1] || "");
  React.useEffect(() => {
    if (onChange) {
      onChange(currentPrefix + " " + currentNumber);
    }
  }, [currentPrefix, currentNumber, onChange]);
  function handlePrefixChange(event: React.ChangeEvent<HTMLSelectElement>) {
    setCurrentPrefix(event.target.value);
  }
  function handleNumberChange(event: React.ChangeEvent<HTMLInputElement>) {
    setCurrentNumber(event.target.value);
  }
  return <div>
      {label && <_StyledSpan>
          {label}
          {rest.required && <_StyledSpan2>*</_StyledSpan2>}
        </_StyledSpan>}
      <_StyledDiv>
        <_StyledDiv2>
          <Select options={prefixes.map(p => ({
          value: p,
          label: p
        }))} defaultValue={currentPrefix} onChange={handlePrefixChange} disabled={rest.disabled} />
        </_StyledDiv2>
        <Input type="tel" value={currentNumber} onChange={handleNumberChange} error={error} {...rest} />
      </_StyledDiv>
    </div>;
}
var _StyledSpan = _styled("span").withConfig({
  componentId: "sc-sf-1afik2-0"
})({
  "marginBottom": "1.6rem",
  "display": "block",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(92 92 92 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  }
});
var _StyledSpan2 = _styled2("span").withConfig({
  componentId: "sc-sf-1afik2-1"
})({
  "marginLeft": "0.8rem",
  "--tw-text-opacity": "1",
  "color": "rgb(75 46 248 / var(--tw-text-opacity))"
});
var _StyledDiv = _styled3("div").withConfig({
  componentId: "sc-sf-1afik2-2"
})({
  "display": "flex",
  "alignItems": "center",
  "columnGap": "0.8rem"
});
var _StyledDiv2 = /*#__PURE__*/_styled4("div").withConfig({
  displayName: "phone-number___StyledDiv2",
  componentId: "sc-aeifws-0"
})({
  "width": "10.4rem",
  "flexShrink": "0"
});